<template>
  <commonView page-type="result" />
</template>
<script>
import commonView from '../components/commonView.vue';
export default {
  name: 'BusinessPurchaseEntryResultDetail',
  components: { commonView },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>
